import { FC } from 'react';
import CustomLink from '@components/CustomLink';
import ProgressIndicator from '@components/ProgressIndicator';
import type { Icon } from '@phosphor-icons/react';
import { m } from 'framer-motion';
import NoodleAI from '@/components/Icons/NoodleAI';
import s from './ListCellNavigation.module.scss';

const ListCellNavigation: FC<{
  onClick?: () => void;
  label: string;
  href?: string;
  icon?: Icon;
  isMuted?: boolean;
  isRouting?: boolean;
  isSelected?: boolean;
  isAi?: boolean;
  newTab?: boolean;
  indented?: boolean;
}> = ({ label, href, icon, isRouting, isSelected, isMuted, isAi, newTab, onClick, indented }) => {
  const IconComponent = icon;

  if (onClick) {
    return (
      <li className={s.item}>
        <button
          onClick={onClick}
          {...(((isSelected || isMuted || indented) && {
            style: {
              ...(isSelected && { backgroundColor: 'var(--color-gray-15)', boxShadow: 'inset 2px 0 0 var(--color-noodle)' }),
              ...(isMuted && { opacity: 0.5 }),
              ...(indented && { paddingLeft: 52 }),
            },
          })
            || undefined)}
        >
          {IconComponent && (isRouting ? <ProgressIndicator /> : <IconComponent weight={isSelected ? 'fill' : 'regular'} size={24} />)}
          <div className={s.content}>
            <p style={isSelected ? { fontWeight: 'bold' } : undefined}>{label}</p>
          </div>
          {(isRouting && !IconComponent && <ProgressIndicator size={16} />)}
        </button>
      </li>
    );
  }
  return (
    <m.li
      className={s.item}
    >
      <CustomLink
        newTab={newTab}
        to={href}
        prefetch={false}
        {...(((isSelected || isMuted || indented) && {
          style: {
            ...(isSelected && { backgroundColor: 'var(--color-gray-15)', boxShadow: 'inset 2px 0 0 var(--color-noodle)' }),
            ...(isMuted && { opacity: 0.5 }),
            ...(indented && { paddingLeft: 52 }),
          },
        })
          || undefined)}
      >
        {isAi
          ? <>{isRouting ? <ProgressIndicator /> : <NoodleAI size={24} />}</>
          : <>
            {IconComponent && (isRouting ? <ProgressIndicator /> : <IconComponent weight={isSelected ? 'fill' : 'regular'} size={24} />)}
          </>}
        <div className={s.content}>
          <p style={isSelected ? { fontWeight: 'bold' } : undefined}>{label}</p>
        </div>
        {(isRouting && !IconComponent && !isAi && <ProgressIndicator size={16} />)}
      </CustomLink>
    </m.li>
  );
};

export default ListCellNavigation;
